import { useMemo } from 'react';
import { appendClassName, makeBEM } from '../../../../../../utils';

var getClassNameByComponent = function getClassNameByComponent(_ref) {
  var component = _ref.component,
      classPrefix = _ref.classPrefix;
  var baseClassNames = makeBEM(classPrefix, component);
  return "".concat(baseClassNames).trim();
};

var useHeaderNavigationMenuContentHeaderClassName = function useHeaderNavigationMenuContentHeaderClassName(classPrefix, className) {
  return useMemo(function () {
    return {
      Root: appendClassName(getClassNameByComponent({
        component: 'Root',
        classPrefix: classPrefix
      }), className),
      Title: getClassNameByComponent({
        component: 'Title',
        classPrefix: classPrefix
      }),
      Label: getClassNameByComponent({
        component: 'Label',
        classPrefix: classPrefix
      }),
      HeaderNavigationMenuContentHeader: getClassNameByComponent({
        component: 'HeaderNavigationMenuContentHeader',
        classPrefix: classPrefix
      }),
      HeaderNavigationMenuContentHeaderItem: getClassNameByComponent({
        component: 'HeaderNavigationMenuContentHeaderItem',
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};

export default useHeaderNavigationMenuContentHeaderClassName;